<template>
    <div class="o-settings">
        <m-title title="Ustawienia" />
        <template v-if="settings">
            <m-control
                type="number"
                label="Numer telefonu"
                placeholder="np. 123456789"
                name="phone"
                @input="build('phone', $event)"
                :value="settings.phone"
            />
            <m-control
                type="radio"
                label="Powiadomienia SMS"
                name="sms_notifications"
                :value="settings.sms_notifications"
                @input="build('sms_notifications', $event)"
                :items="smsNotificationsTypes"
            />
            <o-eko />
            <div class="l-row__column o-settings__subscriptionInfoWrapper">
                <p class="a-text">
                    Subskrypcja: {{ activeSubscription.name }} <br />
                    Aktywna do:
                    {{
                        this.$dayjs(activeSubscription.activeTo).format(
                            'YYYY-MM-DD'
                        )
                    }}
                </p>
                <a
                    @click.prevent="
                        $router.push({ name: 'subscriptionDetails' })
                    "
                    class="a-button a-button--textCenter o-settings__inlineBtn"
                    >Szczegóły</a
                >
            </div>
            <div class="o-terms">
                <div class="o-terms__settings">
                    <p class="a-text o-terms__text">Przeczytaj regulamin</p>
                    <a
                        download="terms.title"
                        :href="terms.file_link"
                        class="a-button o-settings__inlineBtn"
                        target="_blank"
                        >Regulamin</a
                    >
                </div>
            </div>
            <div class="l-row">
                <div class="l-row__column">
                    <a-button
                        type="fullwidth"
                        @click="saveSettings"
                        :is-processing="settingsStatus !== 'idle'"
                        :disable="settingsStatus !== 'idle'"
                    >
                        Zapisz
                    </a-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import OEko from '@/components/OEko'
export default {
    metaInfo: {
        title: 'Ustawienia'
    },
    components: {
        OEko
    },
    data() {
        return {
            smsNotificationsTypes: [
                {
                    value: true,
                    label: 'tak'
                },
                {
                    value: false,
                    label: 'nie'
                }
            ]
        }
    },
    computed: {
        activeSubscription() {
            return this.$store.getters['subscriptions/activeSubscription']
        },
        settings() {
            return this.$store.getters.settings
        },
        settingsStatus() {
            return this.$store.getters.settingsStatus
        },
        terms() {
            return this.$store.getters['termsAndConditions/terms']
        },
        authStatus() {
            return this.$store.getters.authStatus
        }
    },
    methods: {
        build(name, value) {
            this.$store.dispatch('setSettingsField', {
                name,
                value
            })
        },
        saveSettings() {
            this.$store
                .dispatch('saveSettings')
                .then(response => {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: 'Zapisano ustawienia.'
                    })
                })
                .catch(error => {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd.'
                    })
                    console.log(error)
                })
        }
    },
    created() {
        this.$store.dispatch('fetchSettings').then(() => {
            this.$store.dispatch('termsAndConditions/fetchTerms')
        })
    },
    destroyed() {
        this.$store.dispatch('sendExternalUserId')
    }
}
</script>

<style lang="sass">
@import "../styles/main.sass"

body .onesignal-customlink-subscribe
body .onesignal-reset
body .button
    @extend .a-button
    @extend .a-button--fullwidth
    max-width: calc( 100vw - 2rem )
    box-sizing: border-box
    padding: 1rem !important
    text-align: center
    box-shadow: none !important
    font-family: var(--font-family-primary) !important
    text-transform: uppercase !important
    font-size: 14px !important
body .onesignal-customlink-explanation
    font-family: var(--font-family-primary) !important
    font-size: 14px !important
    color: var(--color-text) !important
</style>
